export default {
  title: {
    hr: 'Network error',
    en: 'Network error'
  },

  text: {
    hr: 'Please check your internet connection.',
    en: 'Please check your internet connection.'
  },

  button: {
    hr: 'Done',
    en: 'Done'
  }
};
